import React from 'react';
import { Translate } from 'core/translate';
import { useAppContext } from './AppContext';

const HeaderTitle = () => {
  const { country } = useAppContext();
  return (
    <div className="header-title">
      <div className="header-title__title">
        <Translate value="model.selector.page.title" />
      </div>
      {country === 'US' && (
        <div className="header-title__discount">
          <Translate value="model.selector.discount" />
        </div>
      )}
    </div>
  );
};

export default HeaderTitle;
